export var ATTRIBUTE_PREFIX = "data-rr-ui-";
export var PROPERTY_PREFIX = "rrUi";
export function dataAttr(property) {
  return "".concat(ATTRIBUTE_PREFIX).concat(property);
}
export function dataProp(property) {
  return "".concat(PROPERTY_PREFIX).concat(property);
}